import React from 'react'

const About = () => {
    return (
        <div name="about" className='w-full h-screen bg-[#000000] text-gray-300'>
            <div className="flex flex-col justify-center items-center w-full h-full">
                <div className='max-w-1000px w-full px-4 grid grid-cols-2 gap-8'>
                    <div className='sm:text-right pb-8 pl-4'>
                        <p className='text-4xl font-bold inline border-b-4 border-pink-600'>About me...</p>
                    </div>
                    {/*  */}
                    <div>

                    </div>
                </div>
                <div className="max-w-[1000px] w-full px-4 grid sm:grid-cols-2 gap-8 ">
                    <div className='sm:text-right text-1xl font-semi-bold'>
                        <p> Hye, I'm Aman Singh nice to have you in here i
                            might wanna suggest to take a look around my work.
                            As an enthusiasts who would like to work upon your 
                            ideas and bring you a more prominent application 
                            which works on a decentralized manner within your 
                            control. CONNECT TO RECONNECT....
                        </p>
                    </div>
                    <div>
                        <p>
                            I am passionate about building excellent softwares that improves
                            the lives of people around us. I specialized my learning in creating 
                            software for clients ranging from individual and small-enterprice
                            and keen to work way upto large enterprises. What would you do
                            if you had a software expert available at your fingertips.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default About